import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Standard shadcn/ui className merger. Combines clsx (conditional classes) and
// tailwind-merge (de-duplicates conflicting Tailwind utilities so the rightmost
// wins predictably).
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
